import { connect } from 'react-redux';
import { showReportModal } from '../../../../Moderation/redux/actions';
import { getIsCurrentUserAuthorOf } from '../../../../redux/deviations/selectors';
import { shareDeviationToPost } from '../../../../redux/deviations/actionCreators';
var mapStateToProps = function (state, ownProps) { return ({
    isOwner: getIsCurrentUserAuthorOf(state, ownProps.deviation),
}); };
var mapDispatchToProps = {
    showReportModal: showReportModal,
    shareDeviationToPost: shareDeviationToPost,
};
export default connect(mapStateToProps, mapDispatchToProps);
//# sourceMappingURL=MoreMenuContent.container.js.map